export const HeatmapShaderFrag = () => {
    const fragmentShader = /*glsl*/`
        precision highp float;
        uniform vec3 colors[100];
        uniform int numColors;
        uniform vec2 planeSize;

        // Heat point uniforms - increased array size to handle more points
        uniform vec2 heatPoints[300];
        uniform float intensities[300];
        uniform float radii[300];
        uniform float radius;
        uniform int numPoints;

        varying vec2 vUv;

        float cubicOut(float t) {
            float f = t - 1.0;
            return f * f * f + 1.0;
        }
          

        void main() {
        // Calculate position in world space coordinates
            vec2 position = vec2(
                (vUv.x - 0.5) * planeSize.x,
                (vUv.y - 0.5) * planeSize.y
            );
            
            // Initialize heat value
            float heat = 0.0;

            // Calculate heat contribution from each point
            for (int i = 0; i < 300; i++) {
                if (i >= numPoints) break;
                
                float dist = distance(position, heatPoints[i]);
                // float radius = radii[i];
                
                if (dist < radius) {
                    float normDist = dist / radius;
                    float factor = 1.0 - normDist;
                    // heat = max(heat, intensities[i] * factor * factor * factor); 
                    heat += intensities[i] * pow(factor, 6.0);
                }
            }
            
            // Clamp heat value
            heat = clamp(heat, 0.0, 1.0);
            
            vec3 finalColor = colors[0];
            for(int i = 0; i < numColors; i++) {
                finalColor = mix(finalColor, colors[i], clamp((heat * float(numColors)) * -1.0 + float(numColors - i), 0.0, 1.0));
            }

            gl_FragColor = vec4(finalColor, 1);
        }
        `;

    return fragmentShader;
}

export const HeatmapShaderVert = () => {
    const vertexShader = /*glsl*/`
    varying vec2 vUv;
    
    void main() {
        vUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }`;

    return vertexShader;
}